var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3087_11513)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3087_11513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 5.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3087_11513)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8445 9.32031H10.25V25.6853H23.75V15.0488M17.8445 9.32031L23.75 15.0488M17.8445 9.32031V15.0488H23.75M13.25 28.7528H26.75V18.2528M12.5 18.2528H21.5M12.5 14.5028H15.5M12.5 22.0028H21.5",
    stroke: "#2F3031",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3087_11513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reportsIcon.655e6053849f113e73f28899b5a73a1a.svg";
export { ForwardRef as ReactComponent };